/*****************************************************************************
 * @author: Sandeep Sirohi
 * @description: Utility functions can be placed here.
 ***************************************************************************/


/**
 * @author: Sandeep Sirohi
 * @date: 26/06/2024
 * @description: Display image placeholder in case of image not found.
 * @param {any} e
 */
export const handleImageError = (e) => {
    e.target.onerror = null; // Prevent infinite loop
    e.target.src = process.env.REACT_APP_PUBLIC_URL + '/assets/images/Missing.jpg'; // Replace with your placeholder image path
};
